import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
export var buildLeadTime = function(param, strictLocalize) {
    var leadTimeDays = param.leadTimeDays, upperBoundLeadTimeDays = param.upperBoundLeadTimeDays, lowerBoundLeadTimeDays = param.lowerBoundLeadTimeDays;
    var hasLeadTimeAsRange = upperBoundLeadTimeDays !== lowerBoundLeadTimeDays && isNotUndefined(lowerBoundLeadTimeDays) && isNotUndefined(upperBoundLeadTimeDays);
    if (hasLeadTimeAsRange) {
        return strictLocalize({
            id: "APvjHw",
            defaultMessage: [
                {
                    type: 1,
                    value: "lowerBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: "-"
                },
                {
                    type: 1,
                    value: "upperBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: " days"
                }
            ]
        }, {
            lowerBoundLeadTimeNumber: lowerBoundLeadTimeDays,
            upperBoundLeadTimeNumber: upperBoundLeadTimeDays
        });
    }
    if (leadTimeDays) {
        return strictLocalize({
            id: "IoS4ea",
            defaultMessage: [
                {
                    type: 6,
                    value: "leadTimeDaysNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 0,
                                    value: "a day"
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " days"
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ]
        }, {
            leadTimeDaysNumber: leadTimeDays
        });
    }
    return null;
};
export var buildFulfillmentTime = function(param, strictLocalize) {
    var leadTimeDays = param.leadTimeDays, upperBoundLeadTimeDays = param.upperBoundLeadTimeDays, lowerBoundLeadTimeDays = param.lowerBoundLeadTimeDays;
    var hasLeadTimeAsRange = upperBoundLeadTimeDays !== lowerBoundLeadTimeDays && isNotUndefined(lowerBoundLeadTimeDays) && isNotUndefined(upperBoundLeadTimeDays);
    if (hasLeadTimeAsRange) {
        return strictLocalize({
            id: "0BaogO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Fulfills orders within "
                },
                {
                    type: 1,
                    value: "lowerBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: "-"
                },
                {
                    type: 1,
                    value: "upperBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: " days"
                }
            ]
        }, {
            lowerBoundLeadTimeNumber: lowerBoundLeadTimeDays,
            upperBoundLeadTimeNumber: upperBoundLeadTimeDays
        });
    }
    if (leadTimeDays) {
        return strictLocalize({
            id: "QbOC1P",
            defaultMessage: [
                {
                    type: 6,
                    value: "leadTimeDaysNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 0,
                                    value: "Fulfills orders within a day"
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 0,
                                    value: "Fulfills orders within "
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " days"
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ]
        }, {
            leadTimeDaysNumber: leadTimeDays
        });
    }
    return null;
};
export var buildFulfillmentExplanation = function(param, strictLocalize) {
    var leadTimeDays = param.leadTimeDays, upperBoundLeadTimeDays = param.upperBoundLeadTimeDays, lowerBoundLeadTimeDays = param.lowerBoundLeadTimeDays;
    var hasLeadTimeAsRange = upperBoundLeadTimeDays !== lowerBoundLeadTimeDays && isNotUndefined(lowerBoundLeadTimeDays) && isNotUndefined(upperBoundLeadTimeDays);
    if (hasLeadTimeAsRange) {
        return strictLocalize({
            id: "h2X+KB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Estimated based on purchase date, brand location, brand lead time ("
                },
                {
                    type: 1,
                    value: "lowerBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: "-"
                },
                {
                    type: 1,
                    value: "upperBoundLeadTimeNumber"
                },
                {
                    type: 0,
                    value: " days), and your shipping location."
                }
            ]
        }, {
            lowerBoundLeadTimeNumber: lowerBoundLeadTimeDays,
            upperBoundLeadTimeNumber: upperBoundLeadTimeDays
        });
    }
    if (leadTimeDays) {
        return strictLocalize({
            id: "8ih487",
            defaultMessage: [
                {
                    type: 6,
                    value: "leadTimeDaysNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 0,
                                    value: "Estimated based on purchase date, brand location, brand lead time (a day), and your shipping location."
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 0,
                                    value: "Estimated based on purchase date, brand location, brand lead time ("
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " days), and your shipping location."
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ]
        }, {
            leadTimeDaysNumber: leadTimeDays
        });
    }
    return strictLocalize({
        id: "gHJo1+",
        defaultMessage: [
            {
                type: 0,
                value: "Estimated based on purchase date, brand location, brand lead time, and your shipping location."
            }
        ]
    });
};
